module.exports = __webpack_public_path__ + "img/TE-gram-logo.1726d7c1.png";